import styled from "styled-components";

export const SectionTitle = styled("p")`
  font-weight: 700;
`;
